import { useEffect, useState } from "react";

import { fetchCatalogFamilies } from "../lib/catalogApi";

export const useCatalogFamilies = () => {
  const [families, setFamilies] = useState([]);
  const [isLoadingFamilies, setIsLoadingFamilies] = useState(true);
  const [familiesError, setFamiliesError] = useState("");

  useEffect(() => {
    let isActive = true;

    const loadFamilies = async () => {
      setIsLoadingFamilies(true);
      setFamiliesError("");

      try {
        const nextFamilies = await fetchCatalogFamilies();

        if (isActive) {
          setFamilies(nextFamilies);
        }
      } catch (error) {
        if (isActive) {
          setFamilies([]);
          setFamiliesError(
            error.message || "Unable to load product families right now."
          );
        }
      } finally {
        if (isActive) {
          setIsLoadingFamilies(false);
        }
      }
    };

    loadFamilies();

    return () => {
      isActive = false;
    };
  }, []);

  return {
    families,
    isLoadingFamilies,
    familiesError,
  };
};
